import {
  Autocomplete,
  Button,
  Divider,
  IconButton,
  Paper,
  Switch,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../../../routes/moduleRouteList";
import mastersRouteList from "../../routeList";
import { useMutation, useQuery } from "react-query";
import {
  InsurancePlanType,
  MasterTableDataType,
  SearchParamsType,
} from "./Types";
import { getMastersTableData, saveMasterData } from "./service";
import usePopup from "../../../hooks/usePopup";
import debounce from "../../../utilis/methods/networkHandling";
import { clinicId } from "../../../constants";
import insuanceMatserRouteList from "../routeList";
import useAuthentication from "@hooks/useAuthentication";
import { storageKey } from "./AddOrEditPage";
const pageTitle = "Insurance Plan";
const base = (window as any)._env_?.BASE_URL;
function InsurancePlanMaster() {
  const navigate = useNavigate();
  const { user } = useAuthentication();
  const [searchParams, setSearchParams] = useState<SearchParamsType>({
    pageNumber: 0,
    pageSize: 250,
    filter: {
      searchText: "",
      status: 2,
    },
    sortField: "",
    sortOrder: "",
    clinicId: clinicId,
  });
  const { showSnackbar } = usePopup();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const {
    data: tableData,
    isLoading: tableDataLoading,
    refetch,
  } = useQuery(
    ["", searchParams],
    async () => getMastersTableData(searchParams),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { mutate: updateStatus, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        refetch();
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    pageNumber: number
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      page: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  const handleStatusChange = (
    _: SyntheticEvent,
    value: { label: string; value: number } | null
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        status: value ? value.value : 3,
      },
    }));
  };

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchParams((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        searchText: e.target.value,
      },
    }));
  };

  const debounceSearch = debounce(handleSearchChange, 500);

  const handleNavigateClick = (data?: MasterTableDataType) => {
    navigate(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.masters}/${mastersRouteList.insuranceMaster}/${insuanceMatserRouteList.insurancePlanMasters}/${insuanceMatserRouteList.addOrEdit}`,
      { state: { data: data || null } }
    );
  };

  const handleUpdateOneStatus = (
    status: boolean,
    data: MasterTableDataType,
    plan: InsurancePlanType,
    index: number
  ) => {
    setSelectedId(plan?.planId);
    const inPlanName = data.inPlan;
    inPlanName[index] = {
      planCode: plan.planCode,
      inPlanCreateById: Number(user?.login_id),
      planId: plan?.planId,
      planName: plan?.planName,
      planStatus: status ? 1 : 0,
    };
    updateStatus([
      {
        clinicId: Number(user?.clinicId),
        inGroupId: data.inGroup?.inGroupId || 0,
        inNameId: data.insurance?.insuranceNameId || 0,
        inPlanCreateById: Number(user?.login_id),
        inPlanCode: data?.inPlanCode,
        inTypeId: data?.insuranceType.insTypeId,
        inPlanStatus: status ? 1 : 0,
        inPlanName,
      },
    ]);
  };

  useEffect(()=>{
   localStorage.removeItem(storageKey)
  },[])

  return (
    <div className="p-3">
      <Paper>
        <div className="flex justify-between p-3  ">
          <div className="flex gap-2">
            <Typography variant="h6" color={"default"}>
              {pageTitle} Master
            </Typography>
          </div>
          <div className="flex top-0">
            <Button
              onClick={() => {
                handleNavigateClick();
              }}
            >
              new {pageTitle}
            </Button>
          </div>
        </div>
        <Divider />
        <div className="">
          <div className="grid grid-cols-4 gap-3 py-3 px-2">
            <Autocomplete
              disableClearable
              fullWidth
              defaultValue={
                selectedStatus[
                  searchParams.filter.status as keyof typeof selectedStatus
                ]
              }
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              renderInput={(params) => <TextField {...params} label="Status" />}
              onChange={handleStatusChange}
            />
            <TextField label={"Search"} onChange={debounceSearch} />
          </div>
          <TableContainer className="border">
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                                        <Checkbox
                                            checked={
                                                selectedSize == tableData?.response?.items?.length && tableData?.response?.items?.length > 0
                                            }
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell> */}
                  {headings.map((heading) => (
                    <TableCell key={heading} className="font-bold">
                      {heading}
                    </TableCell>
                  ))}
                  <TableCell className="font-bold">Actions</TableCell>
                </TableRow>
              </TableHead>
              <CustomTableBody
                alert={"No data"}
                dataLoading={tableDataLoading}
                isData={Boolean(tableData?.response?.items?.length)}
                totalSpan={{
                  row: searchParams.pageSize,
                  col: headings.length + 2,
                }}
              >
                {tableData?.response?.items?.map((tableItem, index) =>
                  tableItem?.inPlan?.map((plan, planIndex) => (
                    <TableRow key={`${pageTitle}-${index}-${plan.planId}`}>
                      {/* First row gets the shared cells with rowSpan */}
                      {planIndex === 0 && (
                        <>
                          <TableCell
                            sx={borderStyle}
                            rowSpan={tableItem.inPlan.length}
                          >
                            {tableItem?.insuranceType?.insuranceTypeName}
                          </TableCell>
                          <TableCell
                            sx={borderStyle}
                            rowSpan={tableItem.inPlan.length}
                          >
                            {tableItem?.insurance?.insuranceName}
                          </TableCell>
                          <TableCell
                            sx={borderStyle}
                            rowSpan={tableItem.inPlan.length}
                          >
                            {tableItem?.inGroup?.inGroupId != null
                              ? tableItem?.inGroup.inGroupName
                              : tableItem?.insurance?.insuranceName}
                          </TableCell>
                        </>
                      )}
                      <TableCell sx={borderStyle}>{plan?.planCode}</TableCell>
                      <TableCell sx={borderStyle}>{plan?.planName}</TableCell>
                      <TableCell sx={borderStyle}>
                        {/* <span
                            className={`font-bold ${
                              tableItem?.inPlanStatus
                                ? "text-green-600"
                                : "text-red-600"
                            }`}
                          >
                            {tableItem?.inPlanStatus ? "Active" : "Inactive"}
                          </span> */}

                        {isLoading && plan?.planId == selectedId ? (
                          <CircularProgress size={18} />
                        ) : (
                          <Switch
                            checked={Boolean(plan.planStatus)}
                            disabled={isLoading && plan?.planId == selectedId}
                            onChange={(e) => {
                              handleUpdateOneStatus(
                                e.target.checked,
                                tableItem,
                                plan,
                                planIndex
                              );
                            }}
                          />
                        )}
                      </TableCell>
                      {/* <TableCell sx={borderStyle}>
                        <div className="flex gap-2">
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleNavigateClick(tableItem);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          {isLoading && plan.planId == selectedId && (
                            <CircularProgress size={18} />
                          )}
                        
                        </div>
                      </TableCell> */}
                      {planIndex === 0 && (
                        <TableCell
                          sx={borderStyle}
                          rowSpan={tableItem.inPlan.length}
                        >
                          <div className="flex gap-2">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                handleNavigateClick(tableItem);
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </div>
                        </TableCell>
                      )}
                    </TableRow>
                  ))
                )}
              </CustomTableBody>
            </Table>
            <div className="flex justify-end">
              <TablePagination
                rowsPerPageOptions={[100, 200, 300]}
                component={"div"}
                count={tableData?.response?.totalCount || 0}
                rowsPerPage={searchParams.pageSize}
                page={searchParams.pageNumber}
                sx={{ border: 0 }}
                slotProps={{
                  select: {
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                // ActionsComponent={TablePaginationActions}
              />
            </div>
          </TableContainer>
        </div>
      </Paper>
    </div>
  );
}

export default InsurancePlanMaster;
const headings = [
  "Type Name",
  "Receiver",
  "Payer",
  "Plan Code",
  "Plan Name",
  "Status",
];
const borderStyle = { borderLeft: "1px solid #ccc" };
const statusOptions = [
  { label: "All", value: 2 },
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
];
// const status = [
//   { label: "Active", value: 1 },
//   { label: "Inactive", value: 0 },
// ];
const selectedStatus = {
  2: { label: "All", value: 2 },
  1: { label: "Active", value: 1 },
  0: { label: "Inactive", value: 0 },
};
